<template>
  <div>
    <div class="row">
      <div  class="col-8">
        <div>
          <div>
            <strong>لیست دسته بندی</strong>

          </div>
          <div>

            <Datatable
                :items="items"
                :fields="fields"
                striped

                :items-per-page="20"
                hover
                sorter
                pagination
            >
              <template #row="{item}">

                <td>
                  <p class="text-muted">{{ item.row_id + 1 }}</p>

                </td>

              </template>
              <template #نام="{item}">

                <td>
                  <p class="text-muted">{{ item.cat_title }}</p>

                </td>

              </template>

              <template #تصویر="{item}">


                <td>
                  <CImg width="50px" height="50px" v-bind:src="item.image"/>
                </td>

              </template>

              <template #عملیات="{item,index}">
                <td class="py-2">
                  <button
                      variant="outline"
                      square
                      class="mr-1 form__btn"
                      size="sm"
                      @click="editDetails(item)"
                  >ویرایش
                  </button>
                  <button
                      color="success"
                      variant="outline"
                      square
                      class="mr-1 form__btn"

                      size="sm"
                      @click="goSubCategories(item)"
                  >زیر دسته
                  </button>
                  <button
                      color="danger"
                      variant="outline"
                      square
                      class="mr-1 form__btn"

                      size="sm"
                      @click="delete_item_dialog(item)"
                  >حذف
                  </button>
                </td>
              </template>


            </Datatable>
          </div>

        </div>
      </div>
      <div class="col-4">
        <div>
          <div>
            <strong>ثبت دسته بندی</strong>
          </div>
          <div>
            <div class="row">
              <div class="col-12">
                <CInput
                    v-model="name"

                    label="نام دسته"
                    placeholder="نام دسته"
                />

              </div>
              <div  class="col-12">
                <textarea
                    v-model="description"

                    label="توضیحات دسته"
                    placeholder="توضیحات"

                    rows="4"
                ></textarea>

              </div>
              <div  class="col-12">

                <ImageSelector label=" تصویر (500*500)"
                               v-model:previewImage="previewImage"
                               @imagefile="(n) => file = n"
                />
              </div>
            </div>


          </div>
          <div>
            <CButton v-if="status_form==0"
                @click="login()"
                     class="mr-1"
            >
              ثبت دسته
            </CButton>
            <CButton v-if="status_form!=0"
                @click="login()"
                     class="mr-1"
>
              ویرایش دسته
            </CButton>
            <CButton v-if="status_form!=0"
                @click="reset_form()"
                     class="mr-1">
              انصراف
            </CButton>
          </div>
        </div>
      </div>
    </div>


  </div>

</template>

<script>
import axios from "axios";

import {bus} from '../../../main';
import ImageSelector from "@/views/CustomComponent/ImageSelector.vue";

import Datatable from "@/views/customTable/Datatable";
import CButton from "@/views/CustomComponent/CButton.vue";
export default {
  name: 'Login',
  components: {CButton, ImageSelector,Datatable},
  data() {
    return {
      confirm_delete_name:new Date().getTime()+"_blog_cat",
      name: '',
      file: [],
      color: '',
      previewImage: null,
      description: '',
      items: [],
      fields: [
        {key: 'row',label: '#', _style: 'width:5%'},
        {key: 'تصویر', _style: 'width:10%;'},
        {key: 'نام', _style: 'width:20%'},
        {key: 'عملیات', _style: 'width:10%;'},

      ],

      status_form: 0,

    }
  },
  mounted() {
    this.get_categories();
    // bus.$on(this.confirm_delete_name, (data) => {
    //   // alert(data);
    //   if (data == "true") {
    //     this.delete_item();
    //
    //   } else {
    //     this.status_form = 0;
    //   }
    // });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_categories();
    }
  },
  methods: {

    editDetails(item) {
      this.name = item.cat_title;
      console.log(this.name)
      this.description = item.cat_summary;
      this.previewImage = item.image;
this.file = [item.image_id]
      this.status_form = item.id;

    },
    reset_form() {
      this.name = '';
      this.description = '';
      this.previewImage = null;
      this.file = []

      this.status_form = 0;

    },
    get_categories() {
      var self = this;
var formData = new FormData();
formData.append('cat_id', this.$route.params.cat_id)
      axios.post('/admin/blog/get_categories',formData, {}).then(function (response) {

        var content_cats = response.data;
        self.items = content_cats.orders.map((item, row_id) => {
          return {...item, row_id}
        })

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goSubCategories(item) {

      this.$router.push({path: '/dashboard/news/categories/' + item.id});
    },

    login() {


      let self = this;
      const formData = new FormData()
      let url;
      if (this.status_form == 0) {
        url = "/admin/blog/insert_category";
      } else {
        url = "/admin/blog/update_category";
        formData.append('id', this.status_form)

      }

      formData.append('image', this.file[0]);

      formData.append('name', this.name);
      formData.append('cat', this.$route.params.cat_id);
      formData.append('description', this.description);
      axios.post(url, formData, {}).then((res) => {
        self.get_categories()

        self.$root.modal_component.show_api_response_modals(res);


        if (res.data.error == 0) {
          url = "/admin/category";
          self.name = '';
          self.color = '';
          self.description = '';
          self.previewImage = '';
          self.previewImage_header = '';
          self.status_form = 0;
          self.get_categories();
        }

      })

          // axios.post(  '/admin/category', {
          //     name: self.name,
          //     description: self.description,
          //     image: self.image,
          //     cat: 0,
          // }).then(function (response) {
          //     self.name = '';
          //     self.description = '';
          //     // localStorage.setItem("api_token", response.data.access_token);
          //     // self.$router.push({ path: 'notes' });
          // })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("warning"), this.$t("deleteMessage"), [this.$t("ok")], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/admin/blog/delete_category";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        self.status_form = 0;

        self.get_categories();


      })
          .catch(function (error) {
            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}


</script>
